import React, {Component} from "react";
import FlexView from "react-flexview";
import {connect} from "react-redux";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleDDL from "../../../modules/SimpleDDL";
import ErrorAction from "../../../Redux/ErrorRedux";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import {mapToObjectDDL} from "../../common/mapper";
import {fetchDataAsync} from "../../../Services/Utils";
import { defaultTableChange } from "../../../modules/custom/customTable";

class MasterPenjualanCreate extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (value, tableMeta) => {
                    return <>{tableMeta.rowIndex + 1}</>;
                },
                sort: false,
            },
        },
        {
            name: "userName",
            label: "Username",
        },
        {
            name: "salesLeadName",
            label: "Nama User",
        },
        {
            name: "marketingLine",
            label: "Level",
        },
        {
            name: "salesType",
            label: "Jenis TL",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <SimpleDDL
                        id="select_options_jenisTL"
                        styles={{
                            menu: (provided) => ({
                                ...provided,
                                position: "relative",
                                fontFamily: "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
                            }),
                        }}
                        isClearable
                        value={this.state.jenisTLOptions.find((j) => j.value === val)}
                        options={this.state.jenisTLOptions}
                        onChange={(value) => {
                            this.setState((prevValue) => ({
                                ...prevValue,
                                dataTable: prevValue.dataTable.map((d, idx) =>
                                    idx === rowIndex ? {...d, salesType: value} : d
                                ),
                            }));
                        }}
                        containerclassname="margin-bottom-none"
                        box="search"
                        name="jenisTL"
                    />
                ),
            },
        },
        {
            name: "checked",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <input
                        id="input_checkbox"
                        type="checkbox"
                        checked={val}
                        onChange={() =>
                            this.setState((prevValue) => ({
                                ...prevValue,
                                dataTable: prevValue.dataTable.map((d, idx) =>
                                    idx === rowIndex ? {...d, checked: !d.checked} : d
                                ),
                            }))
                        }
                    />
                ),
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            jenisTLOptions: [],
            dataTable: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        };
    }

    async componentDidMount() {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        let responses = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findSalesNotInSalesLead,
                menuName: "Master Sales",
                setError: this.props.setError,
                args: this.props.kodeCabang,
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                menuName: "Master Sales",
                setError: this.props.setError,
                args: {
                    paramFilters: {
                        bizparCategory: "SALES_TYPE",
                        systemId:"SLSTYP",
                        status: Status.ACTIVE,
                    },
                },
            }),
        ]);

        responses.forEach((response, idx) => {
            if (response.ok) {
                if (idx === 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataTable: response.data.data?.map((d) => ({...d, checked: false})),
                    }));
                } else {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        jenisTLOptions: response.data.data?.map((d) => mapToObjectDDL(d.value, d.key)),
                    }));
                }
            }
        });
        this.setState((prevValue) => ({...prevValue, loading: false}));
    }

    handleSave = async () => {
        this.setState((prevValue) => ({...prevValue, loading: true}));
        this.props.triggerLoading();
        const filteredLead = this.state.dataTable.filter((d) => d.checked);
        const request = {
            salesTeam: filteredLead.map((d) => ({
                employeeId: d.employeeId,
                kodeCabang: this.props.kodeCabang,
                salesLeadId: d.salesId,
                salesType: d.salesType?.value || null,
            })),
        };

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterSales,
            menuName: "Master Sales",
            setError: this.props.setError,
            args: request,
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.props.onClickClose();
            await this.props.onFetch({}, 1, 5);
        }
        this.props.triggerLoading();
        this.setState((prevValue) => ({...prevValue, loading: false}));
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <>
                <SimpleModal
                    title="Form Data Team Lead"
                    visible={this.props.visible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <SimpleDataTable
                                key={`${pagination.page}-${pagination.limit}-${this.state.dataTable.length}`}
                                data={this.state.dataTable}
                                columns={this.tableColumns}
                                toCount={this.state.dataTable.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                            <FlexView hAlignContent="right" className="margin-top-15px">
                                <SimpleButton onClick={this.handleSave}>Simpan</SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterPenjualanCreate);
